import { useContext } from 'react';
import { constructorContext, ConstructorContextState } from '../constructorContext';

export const useConstructorContextState = (): ConstructorContextState['state'] => {
  const { state } = useContext(constructorContext);

  return state;
};
